import "../style.css";
import "./getallvideosfromcloud.css";
import {
  React,
  useState,
  Box,
  Modal,
  toast,
  ReactPlayer,
  styled,
  Paper,
  Grid,
  DeleteOutlineIcon,
  captureeventbaseanalytics,
  OfflinePinIcon,
  RemoveDoneIcon,
  Pagination,
} from "../../../Libraries/Media/index";
import Dropzone from "../../ReactDropZone/FileUploadUsingDropZone";
import { truncateString } from "../../../Utils/stringtruncation";
import ImageLazyLoading from "../../ImageLazyLoad/ImageLazyLoading";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { StyledMenu } from "../../../Utils/StyledMenu";
import { MenuItem } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const GetAllVideosFromCloud = (props) => {
  const [pageNumber, setPageNumber] = useState(1);
  const itemsPerPage = 8;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedVideo, setSelectedVideo] = useState();

  const [data, setdata] = useState({
    videourl: "",
    open: false,
  });

  const openVideo = (link) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      videourl: link,
      open: true,
    }));
  };

  const handleClick = (event, media) => {
    setAnchorEl(event.currentTarget);
    setSelectedVideo(media);
  };

  const closeVideo = () => {
    captureeventbaseanalytics(
      "Media",
      "CLOSE VIDEO/CLOSE VIDEO MODAL",
      "CLOSED"
    );
    setdata((previousvalue) => ({
      ...previousvalue,
      open: false,
    }));
  };

  const handlePlayingError = () => {
    captureeventbaseanalytics("Media", "VIDEO PLAYING ERROR", "ERROR");
    toast.error("Streaming error");
  };

  const handlePageChange = (index) => {
    setPageNumber(index);
  };

  const displayBulletins = props?.videos
    .slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage)
    .map((video, index) => {
      return (
        <Grid item xs={12} md={4} lg={3} key={index}>
          <Item
            style={{
              borderRadius: "0px",
            }}
          >
            <div onClick={() => openVideo(video?.txt_media_streaming_link)}>
              <ImageLazyLoading
                src={video.base64_media_thumbnail}
                alt={"img"}
                width={"100%"}
                height={"200px"}
                style={{ borderRadius: "8px", border: "3px solid #F0F0F0" }}
              />
            </div>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mt={1}
            >
              <span>{truncateString(video.txt_media_full_name, 8)}</span>
              <Box
                flexGrow={1}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                gap={1}
              >
                <span>
                  {video.duration} / {video.media_size}
                </span>
                <div onClick={(e) => handleClick(e, video)}>
                  <MoreVertIcon />
                </div>
              </Box>
            </Box>
          </Item>
        </Grid>
      );
    });

  const pageCount = Math.ceil(props?.videos?.length / itemsPerPage);

  return (
    <>
      {displayBulletins?.length > 0 ? (
        <>
          <Box sx={{ flexGrow: 1, marginBottom: 2 }} id="videos">
            <Grid container spacing={2}>
              {displayBulletins}
              <StyledMenu
                id="media-more-option"
                MenuListProps={{
                  "aria-labelledby": "media-more-option",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem
                  disableRipple
                  onClick={() => {
                    props?.handleEnquireMedia(selectedVideo);
                    setAnchorEl(null);
                  }}
                >
                  <DeleteOutlineIcon />
                  Delete
                </MenuItem>
                {/* <MenuItem
                  disableRipple
                  onClick={() => {
                    props?.handleMediaAsOffline(selectedVideo);
                    setAnchorEl(null);
                  }}
                >
                  <div>
                    {selectedVideo?.is_offline_available === false ? (
                      <>
                        <OfflinePinIcon />
                        Offline
                      </>
                    ) : selectedVideo?.is_offline_available === true ? (
                      <>
                        <RemoveDoneIcon />
                        Online
                      </>
                    ) : null}
                  </div>
                </MenuItem> */}
              </StyledMenu>
            </Grid>
          </Box>
          <Pagination
            count={pageCount}
            color="primary"
            onChange={(event, value) => handlePageChange(value)}
            page={pageNumber}
          />
        </>
      ) : (
        <Dropzone
          getAllMediaFunc={props?.getAllMediaFunc}
          handleIndexChange={props?.handleIndexChange}
        />
      )}

      <Modal
        open={data?.open}
        onClose={closeVideo}
        classNames={{
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            height: "70vh",
            padding: "unset",
            overflow: "hidden",
            borderRadius: "8px",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
            borderRadius: "50%",
          },
        }}
        center
      >
        <ReactPlayer
          url={data.videourl}
          width="100%"
          height="100%"
          playing={true}
          onError={handlePlayingError}
          loop={true}
          controls={true}
        />
      </Modal>
    </>
  );
};

export default GetAllVideosFromCloud;
